import en_US from './en_US'
import es_MX from './es_MX'
import ru_RU from './ru_RU'

import _ from 'lodash'

const translationsObject = {
  en_US: en_US,
  es_MX: _.extend({}, en_US, es_MX),
  ru_RU: _.extend({}, en_US, ru_RU),
};

export default translationsObject;


// WEBPACK FOOTER //
// ./src/i18n/index.js